import React, { Component } from 'react';
import { post,get } from '../utils/request';
import { isPhone } from '../utils/util';

// 机构名称
class OrgName extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orgNameList :[],
      showMask: false,
    }
  }
  static defaultProps = {
    organ: ''
  }
  componentDidMount() {
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
    this.getOrgList(e.target.value)
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.organ;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item ">
        <label className="s-label">机构名称：</label>
        <div className="input-dropdown-wrap">
          <input
            type="text"
            className={classShowName}
            name="organ"
            value={this.props.organ}
            onChange={this.handleChange}
          />
          {
            this.state.showMask &&
            <div className="drop-list">
              {
                this.state.orgNameList.map((org) => {
                  return <div 
                          className="drop-item" 
                          key={org}
                          onClick={ ()=> {
                            this.props.onValueChange({
                              organ:org,
                            })
                            this.setState({
                              orgNameList: [],
                              showMask: false
                            })
                          }}
                          >{org}</div>
                })
              }
            </div>
          }
          {this.state.showMask && 
            <div 
              className="select-mask" 
              onClick={()=>{
                this.setState({
                  showMask: false
                })
              }}
            ></div> 
          }
        </div>
        { showErr && <span className="err-tips">请填写机构名称</span> }
      </div>
    )
  }
  getOrgList = (keyword) => {
    this.setState({
      orgNameList: [],
      showMask: true
    })
    get('/fancube/organ/outer/check/',{
      params:{'keyword': keyword}
    })
    .then( res => {
      this.setState({
        orgNameList: res.data.organs
      })
    })
  }
}

// 关注领域方向
class InterestIndustry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tagNameList: [],
      showMask: false,
      keyword: ''
    }
  }
  static defaultProps = {
    sectors: []
  } 
  handleChange = (e) => {
    if (e.target.name == 'tag-keyword') {
      this.getTagList(e.target.value)
    }

  }
  getTagList = (keyword) => {
    this.setState({
      tagNameList: [],
      showMask: true,
      keyword: keyword
    })
    get('/fancube/tag/check/',{
      params:{'keyword': keyword}
    })
    .then( res => {
      this.setState({
        tagNameList: res.data
      })
      
      if (res.data.length == 0) {
        this.setState({
          showMask: false
        })
      }
    })
  }
  render() {
    const showErr = this.props.checkErr && [].concat(this.props.sectors).length == 0;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`
    return (
      <div className="info-item">
        <label className="s-label">关注领域：</label>
        <div className="multiple-select-wrap">

          <div className="input-dropdown-wrap interest-industry">
            <input
              type="text"
              className="s-input"
              className={classShowName}
              name="tag-keyword"
              placeholder="输入并选择领域"
              onChange={this.handleChange}
            />
            {
              this.state.showMask &&
              <div className="drop-list">
                {
                  this.state.tagNameList.map((tag) => {
                    return <div 
                            className="drop-item" 
                            key={tag}
                            onClick={ ()=> {
                              var _list = this.props.sectors.map( (item) => {return item })
                              if (_list.indexOf(tag) > -1) {

                                this.setState({
                                  tagNameList: [] ,
                                  showMask: false
                                })
                                return
                              }
                              _list = [tag].concat(_list)

                              this.props.onValueChange({
                                sectors: _list,
                              })
                              this.setState({
                                tagNameList: [],
                                showMask: false,
                              })
                            }}
                            >{tag}</div>
                  })
                }
              </div>
            }
            {this.state.showMask && 
              <div 
                className="select-mask" 
                onClick={()=>{
                  this.setState({
                    tagNameList: '',
                    showMask: false,
                  })
                }}
              ></div> 
            }
          </div>
          <div className="add-new-btn" 
            onClick={()=>{
              this.setState({
                showMask: false
              })
              // var _list = this.props.sectors.map( (item) => {return item })
              var _index = [].concat(this.props.sectors).indexOf(this.state.keyword)
              if (_index == -1 && this.state.keyword) {
                var _list = [this.state.keyword].concat(this.props.sectors)
                this.props.onValueChange({
                  sectors: _list
                })
              } 
            }}
          > + 添加</div>
          <div className="tag-item-wrap">
            {
              this.props.sectors && 
              this.props.sectors.map((item)=>{
                return <span className="tag-item" 
                        key={item} 
                        onClick={()=>{ 
                          var _list = [].concat(this.props.sectors)
                          var _index = _list.indexOf(item)
                          _list.splice(_index, 1)
                          this.props.onValueChange({
                            sectors: _list
                          })
                        }}
                        >{item}</span> 
              })
            }
          </div>
       </div> 
        { showErr && <span className="err-tips">请选择关注领域</span> }
      </div>
    )
  }
}

// 投资轮次
class Rounds extends Component {
  
  handleChange = (_val) => {
    // const [key, value] = [e.target.name, e.target.value];
    // this.props.onValueChange({
    //   [key]: value
    // })
  }
  render() {
    const showErr = this.props.checkErr && [].concat(this.props.rounds).length == 0;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    const _round = ['天使轮', 'A轮','B轮','C轮及以上']
    return (
      <div className="info-item">
        <label className="s-label">投资轮次：</label>
        { isPhone() && <br/> }
        {
          _round.map( (item) => {
            const classShowName = `round-item ${[].concat(this.props.rounds).indexOf(item) > -1 ? 'round-item-active':''}`;
            return <div 
              className={classShowName} 
              value={item}
              key={item}
              onClick={() => {
                var _index = [].concat(this.props.rounds).indexOf(item)
                var _rounds = []
                if (_index == -1) {
                  _rounds = [item].concat(this.props.rounds);
                } else {
                  _rounds = [].concat(this.props.rounds);
                  _rounds.splice(_index, 1)
                }
                this.props.onValueChange({
                  'rounds': _rounds
                })
              }}
              >{item}</div>
          })
        }
         { showErr && <span className="err-tips">请选择投资轮次</span> }
      </div>
    )
  }
}
// 职位
class Position extends Component {
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.position;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">职位：</label>
        <input
          type="text"
          className={classShowName}
          name="position"
          value={this.props.position}
          onChange={this.handleChange}
          />
          { showErr && <span className="err-tips">请填写职位</span> }
      </div>
    )
  }
}
// Portfolio 
class Portfolio extends Component {
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    return (
      <div className="info-item">
        <label className="s-label">投资案例：</label>
        <textarea
          className="s-textarea"
          name="portfolio"
          placeholder="多个投资案例用逗号隔开"
          value={this.props.portfolio}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

class Investor extends Component {
  constructor (props) {
    super(props);
    this.state = { ...this.props};
    this.isRight = true;
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    validateMap.set('classValidate', ['organ', 'position', 'rounds', 'sectors']);
    for (let i in this.state) {
      if (validateMap.get('classValidate').indexOf(i) > -1 && (!this.state[i] || this.state[i].length == 0 )) {
        flag = false;
      }
    }
    return flag;
  }
  handleValueChange = (resObj) => {
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    return (
      <div className="investor-content padding-top-30">
        <p className="s-title">投资偏好</p>
        <OrgName 
          organ={this.state.organ}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Position
          position={this.state.position}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Rounds
          rounds={this.state.rounds}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <InterestIndustry
          sectors={this.state.sectors}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Portfolio
          portfolio={this.state.portfolio}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

export default Investor